import { Controller } from "@hotwired/stimulus";
import Choices from "choices.js";
import "choices.js/public/assets/styles/choices.css";

export default class extends Controller {
  static values = { disableRemoveItem: Boolean };

  declare readonly disableRemoveItemValue: boolean;

  connect() {
    new Choices(this.element, {
      allowHTML: false,
      editItems: true,
      removeItemButton: !this.disableRemoveItemValue,
      shouldSort: false,
      noResultsText: "選択肢がありません", // 検索結果がないときに表示するメッセージ
      noChoicesText: "該当する結果がありません", // 選択可能なオプションがないときに表示するメッセージ
      itemSelectText: "選択",
      classNames: {
        containerOuter: ["choices", "w-full"],
        containerInner: [
          "block",
          "w-full",
          "rounded-md",
          "border",
          "border-gray-300",
          "bg-white",
          "px-2.5",
          "py-1.5",
          "text-gray-900",
          "focus:border-blue-500",
          "focus:ring-blue-500",
        ],
        input: "choices__input",
        inputCloned: "choices__input--cloned",
        list: "choices__list",
        listItems: "choices__list--multiple",
        listSingle: "choices__list--single",
        listDropdown: "choices__list--dropdown",
        item: "choices__item",
        itemSelectable: "choices__item--selectable",
        itemDisabled: "choices__item--disabled",
        itemChoice: "choices__item--choice",
        placeholder: "choices__placeholder",
        group: "choices__group",
        groupHeading: "choices__heading",
        button: "choices__button",
        activeState: "is-active",
        focusState: "is-focused",
        openState: "is-open",
        disabledState: "is-disabled",
        highlightedState: "is-highlighted",
        selectedState: "is-selected",
        flippedState: "is-flipped",
        loadingState: "is-loading",
        noResults: "has-no-results",
        noChoices: "has-no-choices",
      },
    });
  }
}
